// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","377":"2e3a845b","869":"styles"}[chunkId] + "-" + {"293":"f154d31135298ebbd30b","377":"a37c532402ee15da043e","869":"6d43ef72e9bff41431d1"}[chunkId] + ".js";
};